import { Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";

// Small, reusable row of two actions surfaced anywhere a renter needs
// day-of-pickup help: copy the street address to clipboard and open
// turn-by-turn directions in Google Maps.
//
// Renders nothing when there's no address to act on.
export const PickupActions = ({ address, testIdPrefix = "pickup" }) => {
    const trimmed = (address || "").trim();
    if (!trimmed) return null;

    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(trimmed)}`;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(trimmed);
            toast.success("Address copied to clipboard");
        } catch {
            // Fallback for older browsers / non-secure contexts
            const ta = document.createElement("textarea");
            ta.value = trimmed;
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            try {
                document.execCommand("copy");
                toast.success("Address copied to clipboard");
            } catch {
                toast.error("Couldn't copy — long-press to select and copy");
            } finally {
                document.body.removeChild(ta);
            }
        }
    };

    return (
        <div className="mt-2 flex flex-wrap gap-2">
            <button
                type="button"
                onClick={copy}
                data-testid={`${testIdPrefix}-copy-btn`}
                className="inline-flex items-center gap-1.5 rounded-full border border-[#737a3d]/40 bg-[#F4F1EA] px-3 py-1.5 text-[11px] font-bold uppercase tracking-widest text-[#737a3d] transition-colors hover:bg-[#737a3d]/10"
            >
                <Copy className="h-3 w-3" strokeWidth={2.5} />
                Copy address
            </button>
            <a
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${testIdPrefix}-directions-link`}
                className="inline-flex items-center gap-1.5 rounded-full bg-[#737a3d] px-3 py-1.5 text-[11px] font-bold uppercase tracking-widest text-[#F4F1EA] transition-colors hover:bg-[#5a6142]"
            >
                <ExternalLink className="h-3 w-3" strokeWidth={2.5} />
                Get directions
            </a>
        </div>
    );
};

export default PickupActions;
